<!-- 代码已包含 CSS：使用 TailwindCSS , 安装 TailwindCSS 后方可看到布局样式效果 -->

<template>
    <div class="min-h-screen bg-gray-50 p-8">
      <!-- 头部区域 -->
      <!-- <div class="mb-8 flex items-center justify-between">
        <h1 class="text-2xl font-bold text-gray-800">客户订货报表</h1>
        <div class="flex items-center gap-4">
          <button class="!rounded-button flex items-center gap-2 bg-blue-600 px-4 py-2 text-white hover:bg-blue-700">
            <i class="fas fa-download"></i>
            导出报表
          </button>
        </div>
      </div> -->
  
      <!-- 筛选条件区域 -->
      <div class="mb-8 rounded-lg bg-white p-6 shadow-sm">
        <div class="xrow-ycenter">
          <div class="relative"  v-if="isuse == 1">
                <button @click="toggleSupplierDropdown" class="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-button bg-white text-gray-700 hover:bg-gray-50">
                  <i class="fas fa-building"></i>
                  <span class="whitespace-nowrap">{{ selectedSupplier.name || '选择供应商' }}</span>
                  <i class="fas fa-chevron-down text-gray-400"></i>
                </button>
                <div v-if="showSupplierDropdown" class="absolute z-10 w-56 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg">
                  <div class="py-2">
                    <div v-for="item in supply" :key="item.supply_id" @click="selectSupplier(item)" class="px-4 py-2 hover:bg-gray-50 cursor-pointer">
                       {{item.name}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="relative" style="margin: 0 20px;">
                <el-select v-model="form.store_id" placeholder="请选择门店">
                   <el-option key="0" label="全部" value="0"></el-option>
                    <el-option v-for="(item,index) in storeList" :key="index" :label="item.store_name" :value="item.store_id"></el-option>
                </el-select>
              </div>
          <div class="relative">
            <!-- 日期范围选择 -->
            <div class="flex items-center gap-2">
            <input type="date" v-model="form.startDate" class="px-4 py-2 border border-gray-200 rounded-button bg-white text-gray-700">
              <span class="text-gray-500">至</span>
              <input type="date" v-model="form.endDate" class="px-4 py-2 border border-gray-200 rounded-button bg-white text-gray-700">
              </div>
          
  
          </div>
  
          <button @click="search" class="!rounded-button flex items-center px-4 py-2 bg-blue-600 text-white hover:bg-blue-700" style="width: 60px;height: 36px;margin-left: 20px;">
                查询
              </button>
        </div>
      </div>
  
      <!-- 数据概览区域 -->
      <div class="mb-8 grid grid-cols-4 gap-6">
        <div v-for="(stat, index) in statistics" :key="index" class="rounded-lg bg-white p-6 shadow-sm">
          <div class="mb-2 text-sm text-gray-500">{{ stat.label }}</div>
          <div class="flex items-end gap-2">
            <span class="text-2xl font-bold text-gray-800">{{ stat.value }}</span>
            <span v-if="stat.unit" class="text-sm text-gray-500">{{ stat.unit }}</span>
          </div>
          <div v-if="stat.trend" :class="`mt-2 text-sm ${stat.trend > 0 ? 'text-green-500' : 'text-red-500'}`">
            <i :class="`fas fa-arrow-${stat.trend > 0 ? 'up' : 'down'} mr-1`"></i>
            {{ Math.abs(stat.trend) }}% 环比
          </div>
        </div>
      </div>
  
      <!-- 图表区域 -->
      <div class="mb-8 grid grid-cols-2 gap-6">
        <div class="rounded-lg bg-white p-6 shadow-sm">
          <h3 class="mb-4 text-lg font-medium text-gray-800">订单趋势</h3>
          <div ref="orderTrendChart" style="height: 300px"></div>
        </div>
        <div class="rounded-lg bg-white p-6 shadow-sm">
          <h3 class="mb-4 text-lg font-medium text-gray-800">产品类别分布</h3>
          <div ref="categoryChart" style="height: 300px"></div>
        </div>
      </div>
  
      <!-- 表格区域 -->
      <div class="rounded-lg bg-white shadow-sm">
        <table class="w-full">
          <thead>
            <tr class="border-b text-left">
              <th v-for="col in tableColumns" :key="col.key" class="p-4 font-medium text-gray-600">
                {{ col.label }}
                <i v-if="col.sortable" class="fas fa-sort ml-1 text-gray-400"></i>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="order in orders" :key="order.order_id" class="border-b hover:bg-gray-50">
              <td class="p-4">{{ order.order_id }}</td>
              <td class="p-4">{{ order.customer }}</td>
              <td class="p-4">{{ order.date }}</td>
              <!-- <td class="p-4">{{ order.products }}</td> -->
              <td class="p-4 font-medium">¥{{ order.amount.toLocaleString() }}</td>
              <td class="p-4">
                <span :class="`rounded-full px-2 py-1 text-xs ${order.status === '已发货' ? 'bg-green-100 text-green-600' : 'bg-yellow-100 text-yellow-600'}`">
                  {{ order.status }}
                </span>
              </td>
              <!-- <td class="p-4">
                <button class="!rounded-button text-sm text-blue-600 hover:text-blue-700">
                  查看详情
                </button>
              </td> -->
            </tr>
          </tbody>
        </table>
        
        <!-- 分页 -->
        <div class="pagination">
              <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              background :current-page="curPage"
              :page-sizes="[20, 100,500, 1000]"
              layout="total,sizes, prev, pager, next, jumper"
              :total="totalDataNumber"></el-pagination>
          </div>
      </div>
    </div>
  </template>
  
  <script>
  import * as echarts from 'echarts';
  import StatisticsApi from '@/api/statistics.js';
  import HorderApi from '@/api/horder.js'
  export default {
    data() {
      return {
        storeList:[],
        selectedSupplier: {'name':""},
          showSupplierDropdown: false,
          startDate: '',
          endDate: '',
          supply:[],
          isuse:0,
          selectedSuppliers: {'store_name':""},
          showSupplierDropdowns: false,
          store:[],
  
        form: {
          customerName: '',
          status: '',
          category: '',
          dateRange: '',
          startDate: '',
          endDate: '',
          supply_id:0,
          store_id:"0",
        },
        statistics: [
          { label: '订单总数', value: '', trend: 5 },
          { label: '订单总金额', value: '', unit: '元', trend: 12 },
          { label: '待发货订单', value: '', trend: -3 },
          { label: '本月订单数', value: '', trend: 8 }
        ],
        tableColumns: [
          { key: 'order_id', label: '订单编号', sortable: true },
          { key: 'customer', label: '客户名称', sortable: true },
          { key: 'date', label: '下单时间', sortable: true },
          // { key: 'products', label: '产品信息' },
          { key: 'amount', label: '订单金额', sortable: true },
          { key: 'status', label: '订单状态' },
          // { key: 'action', label: '操作' }
        ],
        orders: [
        ],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
  
      };
    },
    mounted() {
      var self = this;
      this.getInas({},function(res){
        self.isuse = res
      })
      this.getSupplys();
      this.search();
      this.getList();
      // this.initOrderTrendChart();
      // this.initCategoryChart();
    },
    methods: {
      // 筛选列表
      getList(){
          let that = this
          HorderApi.sceenList({},true).then((res) => {
              console.log("sceenitem",res)
              if(res.code == 1){
                  that.storeList = res.data.store_list
                  // that.supply = res.data.supply_list
              }
          })
      },
      search(){
        this.getOrderStatisticss();
        this.getOrderTrends();
        this.getProductCategoryDistribution();
        this.getOrderLists();
      },
      getOrderLists(){
        let self = this;
        let Params = self.form
          Params.page = self.curPage
          Params.list_rows = self.pageSize
          StatisticsApi.getOrderLists(Params, true)
          .then(res => {
              self.orders = res.data.list;
              self.totalDataNumber = res.data.total;
  
          })
          .catch(error => {});
      },
               /*选择第几页*/
               handleCurrentChange(val) {
              this.curPage = val
              this.getOrderLists()
              },
              /*每页多少条*/
              handleSizeChange(val) {
              this.curPage = 1
              this.pageSize = val
              this.getOrderLists()
          },  
      getProductCategoryDistribution(){
        let self = this;
        const chart = echarts.init(self.$refs.categoryChart);
        StatisticsApi.getProductCategoryDistribution(self.form, true)
        .then(res => {
         
  
        chart.setOption(res.data);
        })
        .catch(error => {});
      },
      getOrderStatisticss(){
        let self = this;
        StatisticsApi.getOrderStatisticss(self.form, true)
        .then(res => {
            self.statistics = res.data;
        })
        .catch(error => {});
      },
      getOrderTrends(){
        let self = this;
        const chart = echarts.init(self.$refs.orderTrendChart);
        StatisticsApi.getOrderTrends(self.form, true)
        .then(res => {
  
          chart.setOption(res.data);
  
        })
        .catch(error => {});
      },
  
  
  
  
  
  
  
  
      getSupplys(){
              let self = this;
      
      
              StatisticsApi.getSupply({}, true)
                  .then(data => {
                
                  self.supply = data.data
             
                  })
                  .catch(error => {
                  });
          },
          getStore(){
              let self = this;
      
      
              StatisticsApi.getStore({}, true)
                  .then(data => {
                
                  self.store = data.data
             
                  })
                  .catch(error => {
                  });
          },
         toggleSupplierDropdown() {
          this.showSupplierDropdown = !this.showSupplierDropdown;
        },
        selectSupplier(supplier) {
          this.selectedSupplier = supplier;
          this.showSupplierDropdown = false;
          this.form.supply_id = supplier.supply_id
          this.form.store_id = "";
          this.getStore();
        },
        toggleSupplierDropdowns() {
          this.showSupplierDropdowns = !this.showSupplierDropdowns;
          
        },
        selectSuppliers(supplier) {
          this.selectedSuppliers = supplier;
          this.showSupplierDropdowns = false;
          this.form.store_id = supplier.store_id
          
        },
      initOrderTrendChart() {
        const chart = echarts.init(this.$refs.orderTrendChart);
        const option = {
          animation: false,
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: ['8月', '9月', '10月', '11月', '12月', '1月', '2月']
          },
          yAxis: {
            type: 'value'
          },
          series: [{
            data: [150, 230, 224, 218, 135, 147, 260],
            type: 'line',
            smooth: true,
            color: '#3B82F6'
          }]
        };
        chart.setOption(option);
      },
      initCategoryChart() {
        const chart = echarts.init(this.$refs.categoryChart);
        const option = {
          animation: false,
          tooltip: {
            trigger: 'item'
          },
          legend: {
            orient: 'vertical',
            right: 10,
            top: 'center'
          },
          series: [{
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['40%', '50%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '14',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [
       
            ]
          }]
        };
        chart.setOption(option);
      }
    }
  };
  </script>
  
  <style scoped>
  /* 移除number input的箭头 */
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }
  </style>
  
  


// WEBPACK FOOTER //
// src/views/store/storeorder/index.vue